import React, { useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import { ApplicationSdk } from '../../../../core/sdk';
import { ProgressSpinner } from 'primereact/progressspinner';
import OrderNew from './OrderNew';
import OrderView from './OrderView';
import OrderNewStore from '../stores/OrderNewStore';
import OrderViewStore from '../stores/OrderViewStore';
import OrderOverview from './OrderOverview';
import OrderOverviewStore, { OrderOverviewState } from '../stores/OrderOverviewStore';

const OrderEmployeePage = observer(({ sdk }: { sdk: ApplicationSdk }) => {
    useEffect(() => {
        sdk.useStore(OrderOverviewStore);
    }, [sdk]);

    const { currentStore }: { currentStore: OrderOverviewStore } = sdk;
    if (currentStore === null) {
        return null;
    }

    // Show a loading spinner if the store is loading
    if (currentStore?.isLoading) {
        return (
            <div
                style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    height: '50vh',
                    flexDirection: 'column',
                    gap: '1rem',
                }}
            >
                <ProgressSpinner
                    style={{
                        width: '50px',
                        height: '50px',
                    }}
                    strokeWidth="4"
                    animationDuration="1s"
                />
                <div
                    style={{
                        color: '#6c757d',
                        fontSize: '1rem',
                        textAlign: 'center',
                    }}
                >
                    Daten werden geladen...
                </div>
            </div>
        );
    }

    switch (currentStore.state as OrderOverviewState) {
        case OrderOverviewState.New:
            return (
                <OrderNew
                    sdk={sdk}
                    orderNewStore={currentStore.currentWindowStore as OrderNewStore}
                />
            );

        case OrderOverviewState.View:
            return (
                <OrderView
                    sdk={sdk}
                    orderViewStore={currentStore.currentWindowStore as OrderViewStore}
                />
            );

        case OrderOverviewState.Overview:
        default:
            return (
                <OrderOverview
                    sdk={sdk}
                    currentStore={currentStore}
                />
            );
    }
});

export default OrderEmployeePage;
